import { AxiosResponse } from "axios";
import { StatusEnvioExecucao } from "@/shared/enumeradores";
import axios from "./axios-handler.service";

const BASE_URL = "/api/Relatorios";

export interface GerarRelatorioClienteEnvioAutomaticoCommand {
  idEnvioAutomatico: number;
  dataExecucao: string;
  consultor: string;
  statusEnvio: StatusEnvioExecucao | null;
}

export interface ProdutoMaisVendido {
  NomeCatalogo: string;
  NomeProduto: string;
  QuantidadeVendida: number;
  UrlImagem: string | null;
}

export class RelatorioService {
  static async GerarRelatorioCliente(periodo: string, tipoRelatorio: string): Promise<{relatorio: any[]}> {
    const response = await axios.get(`${BASE_URL}/GerarRelatorioCliente`, {
      params: {
        periodo,
        tipoRelatorio
      }
    });
    return response.data;
  }

  static async GerarRelatorioProdutosMaisVendidos(periodo: string, idsCatalogo: string[]): Promise<ProdutoMaisVendido[]> {
    const response = await axios.post(`${BASE_URL}/GerarRelatorioProdutosMaisVendidos`, {
      periodo,
      idsCatalogo
    });

    // A action devolve uma string montada com JsonConvert (e nao um objeto) para as chaves
    // sairem em PascalCase, e nao no camelCase que o MVC aplica aqui. O axios desserializa
    // essa string sozinho, entao o corpo pode chegar nas duas formas.
    const dados = typeof response.data === "string" ? JSON.parse(response.data) : response.data;

    return (dados && dados.Relatorio) || [];
  }

  static async GerarRelatorioClientesEnviosAutomaticos(command: GerarRelatorioClienteEnvioAutomaticoCommand): Promise<void> {
    return await axios
      .post(`${BASE_URL}/GerarRelatorioClientesEnviosAutomaticos`, command, {
        responseType: "blob",
      })
      .then(this.downloadResponse);
  }

  private static async downloadResponse(
    response: AxiosResponse<Blob>,
    fileNameDefault = "default.file"
  ): Promise<void> {
    const href = window.URL.createObjectURL(response.data);

    const anchorElement = document.createElement("a");
    anchorElement.href = href;
    anchorElement.style.display = "none";

    const contentDisposition = response.headers["content-disposition"];

    let fileName = fileNameDefault;

    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/);
      if (fileNameMatch?.length === 2) {
        fileName = fileNameMatch[1];
      }
    }

    anchorElement.download = fileName;

    document.body.appendChild(anchorElement);
    anchorElement.click();

    document.body.removeChild(anchorElement);
    window.URL.revokeObjectURL(href);
  }
}